<template>
  <div>
    <div class="mb-10 pa-3">
      <info-box label="All bikes" :value="allBikes"></info-box>
    </div>
    <div class="page-body">
      <v-data-table class="app-table" :headers="headers" :items="data" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer="hide-default-footer" item-key="id" :show-select="mode === 'edit'" :value="selected" @input="updateSelected" @click:row="toInfoPage" @page-count="pageCount = $event" :no-data-text="$t('common.nodata')">
        <template v-slot:item.actions>
          <v-icon small="small">mdi-chevron-right</v-icon>
        </template>
      </v-data-table>
      <div class="text-center mt-10">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QueryMode from '@/mixins/QueryMode'
import InfoBox from '@/components/Share/InfoBox'

export default {
  components: { InfoBox },
  mixins: [QueryMode],
  data () {
    return {
      allBikes: 103,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'Model', sortable: false, value: 'model' },
        { text: 'Bike ID', sortable: false, value: 'id' },
        { text: 'Status', sortable: false, value: 'status' },
        { text: 'Rental', sortable: false, value: 'rental' },
        { text: 'Production Date', value: 'productionDate' },
        { text: 'Battery', sortable: false, value: 'battery' },
        { text: 'Maintenance', sortable: false, value: 'maintenance' },
        { text: '', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters({
      data: 'bikes/list',
      selected: 'bikes/selected'
    })
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapActions({
      fetchData: 'bikes/fetch',
      updateSelected: 'bikes/updateSelected'
    }),
    toInfoPage (data) {
      this.$router.push(`/bikes/${data.id}`)
    }
  }
}
</script>
